import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Tree from '../../core/Tree';
import DataTreeItem from './DataTreeItem';
/**
 * @extends {React.Component<import('./types').DataTreeProps> }
 */

var DataTree =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataTree, _React$Component);

  function DataTree() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataTree);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataTree)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleItemClick = function (node) {
      var onChange = _this.props.onChange;
      if (onChange) onChange(node);
    };

    return _this;
  }

  _createClass(DataTree, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          tree = _this$props.tree,
          value = _this$props.value,
          lightTheme = _this$props.lightTheme;
      return React.createElement(Tree, {
        tree: tree,
        renderNode: function renderNode(node) {
          return React.createElement(DataTreeItem, Object.assign({}, node, {
            lightTheme: lightTheme,
            selected: node.xpath === value,
            onClick: function onClick() {
              return _this2.handleItemClick(node);
            }
          }));
        }
      });
    }
  }]);

  return DataTree;
}(React.Component);

DataTree.defaultProps = {
  lightTheme: false,
  tree: {},
  value: null,
  onChange: null
};
export default DataTree;